import { useState } from "react";
import { PacienteAdminUpdate } from "./PacienteAdminUpdate";
import { PacienteAdminDelete } from "./PacienteAdminDelete";
import { Link, useNavigate, useLoaderData } from "react-router-dom";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import es from "react-phone-input-2/lang/es.json";

export function PacienteAdminEdit() {
  const paciente = useLoaderData();

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  const navigate = useNavigate();

  const [firstName, setFirstName] = useState(paciente?.first_name);
  const [lastName, setLastName] = useState(paciente?.last_name);
  const [sexoPacie, setSexoPacie] = useState(paciente?.meta?.sexo_paciente);
  const [direccion, setDireccion] = useState(paciente?.meta?.direccion);
  const [direccionNum, setDireccionNum] = useState(paciente?.meta?.direccion_num);
  const [direccionPiso, setDireccionPiso] = useState(paciente?.meta?.direccion_piso);
  const [direccionCiudad, setDireccionCiudad] = useState(paciente?.meta?.direccion_ciudad);
  const [direccionProvincia, setDireccionProvincia] = useState(paciente?.meta?.direccion_provincia);
  const [direccionCp, setDireccionCp] = useState(paciente?.meta?.direccion_cp);
  const [email, setEmail] = useState(paciente?.email);
  const [telefono, setTelefono] = useState(paciente?.meta?.telefono);
  const [dni, setDni] = useState(paciente?.meta?.dni);
  const [nacimiento, setNacimiento] = useState(paciente?.meta?.nacimiento);
  const [username, setUsername] = useState(paciente?.username);
  const [hce, setHce] = useState(paciente.meta?.hce);
  const [nombreFamiliar, setNombreFamiliar] = useState(paciente.meta?.nombre_familiar);
  const [telefonoFamiliar, setTelefonoFamiliar] = useState(paciente.meta?.telefono_familiar);
  const [estadoUsuario, setEstadoUsuario] = useState(paciente.meta?.estado || 'activo');
  const [credito, setCredito] = useState(paciente?.meta?.credito);

  let pacienteId = paciente.id;

  const submitPacienteAdmin = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      firstName,
      lastName,
      sexoPacie,
      direccion,
      direccionNum,
      direccionPiso,
      direccionCiudad,
      direccionProvincia,
      direccionCp,
      email,
      telefono,
      dni,
      nacimiento,
      username,
      hce,
      nombreFamiliar,
      telefonoFamiliar,
      estadoUsuario,
      credito,
      pacienteId
    );
    try {
      await PacienteAdminUpdate(
        firstName,
        lastName,
        sexoPacie,
        direccion,
        direccionNum,
        direccionPiso,
        direccionCiudad,
        direccionProvincia,
        direccionCp,
        email,
        telefono,
        dni,
        nacimiento,
        username,
        hce,
        nombreFamiliar,
        telefonoFamiliar,
        estadoUsuario,
        credito,
        pacienteId
      ).then(
        (val) => {
          navigate(`../pacientes/${pacienteId}`);
          console.log(val);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteUser = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await PacienteAdminDelete(pacienteId).then(
        (val) => {
          navigate(`../pacientes`);
          console.log(val);
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        <form id='formUpdatelement' onSubmit={submitPacienteAdmin}>
          <fieldset id='disabledContainer'>
            <h3>Actualizar Paciente</h3>
            <div className='grid--2col'>
              <div className='field'>
                <label htmlFor='firstName'>Nombre</label>
                <div className='control'>
                  <input
                    className='input'
                    id='firstName'
                    required
                    type='text'
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='lastName'>Apellidos</label>
                <div className='control'>
                  <input
                    className='input'
                    id='lastName'
                    required
                    type='text'
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className='grid--2col'>
              <div className='field'>
                <label htmlFor='sexoPacie'>Sexo</label>
                <div className='control'>
                  <div className='select'>
                    <select
                      className='select'
                      id='sexoPacie'
                      required
                      name='sexoPacie'
                      value={sexoPacie}
                      onChange={(e) => setSexoPacie(e.target.value)}
                    >
                      <option disabled value=''>
                        -- Selecciona una opción --
                      </option>
                      <option value='hombre'>Hombre</option>
                      <option value='mujer'>Mujer</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='field'>
                <label htmlFor='direccion'>Dirección</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccion'
                    type='text'
                    value={direccion}
                    onChange={(e) => setDireccion(e.target.value)}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='direccionNum'>Número</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionNum'
                    type='text'
                    value={direccionNum}
                    onChange={(e) => setDireccionNum(e.target.value)}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='direccionPiso'>Piso</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionPiso'
                    type='text'
                    value={direccionPiso}
                    onChange={(e) => setDireccionPiso(e.target.value)}
                  />
                </div>
              </div>

              <div className='field'>
                <label htmlFor='direccionCiudad'>Población</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionCiudad'
                    type='text'
                    value={direccionCiudad}
                    onChange={(e) => setDireccionCiudad(e.target.value)}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='direccionProvincia'>Provincia</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionProvincia'
                    type='text'
                    value={direccionProvincia}
                    onChange={(e) => setDireccionProvincia(e.target.value)}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='direccionCp'>Código postal</label>
                <div className='control'>
                  <input
                    className='input'
                    id='direccionCp'
                    type='text'
                    value={direccionCp}
                    onChange={(e) => setDireccionCp(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className='grid--2col'>
              <div className='field'>
                <label htmlFor='email'>Email</label>
                <div className='control'>
                  <input
                    className='input'
                    id='email'
                    required
                    type='email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='telefono'>Teléfono Móvil</label>
                <div className='control'>
                  <PhoneInput
                    inputProps={{
                      className: "input",
                      name: "telefono",
                      required: true,
                      id: "telefono",
                    }}
                    placeholder='+34 658 309 174'
                    localization={es}
                    value={telefono}
                    country={"es"}
                    onChange={(value) => setTelefono(value)}
                  />
                </div>
              </div>
            </div>

            <div className='grid--2col'>
              <div className='field'>
                <label htmlFor='dni'>NIF/Pasaporte</label>
                <div className='control'>
                  <input
                    className='input'
                    id='dni'
                    required
                    type='text'
                    value={dni}
                    onChange={(e) => setDni(e.target.value)}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='nacimiento'>Fecha de nacimiento</label>
                <div className='control'>
                  <input
                    className='input'
                    id='nacimiento'
                    required
                    type='date'
                    value={nacimiento}
                    onChange={(e) => setNacimiento(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='username'>Nombre de usuario</label>
              <div className='control'>
                <input
                  className='input'
                  disabled
                  readOnly
                  id='username'
                  type='text'
                  value={username}
                />
              </div>
            </div>
          </div> */}

            <div className='grid--2col'>
              <div className='field'>
                <label htmlFor='hce'>NHC</label>
                <div className='control'>
                  <input
                    className='input'
                    id='hce'
                    required
                    type='number'
                    value={hce}
                    onChange={(e) => setHce(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className='grid--2col'>
              <div className='field'>
                <label htmlFor='nombreFamiliar'>Nombre de familiar</label>
                <div className='control'>
                  <input
                    className='input'
                    id='nombreFamiliar'
                    type='text'
                    value={nombreFamiliar}
                    onChange={(e) => setNombreFamiliar(e.target.value)}
                  />
                </div>
              </div>
              <div className='field'>
                <label htmlFor='telefonoFamiliar'>
                  Número de teléfono de familiar
                </label>
                <div className='control'>
                  <PhoneInput
                    inputProps={{
                      className: "input",
                      name: "telefonoFamiliar",
                      id: "telefonoFamiliar",
                    }}
                    placeholder='+34 658 309 174'
                    localization={es}
                    value={telefonoFamiliar}
                    country={"es"}
                    onChange={(value) => setTelefonoFamiliar(value)}
                  />
                </div>
              </div>
            </div>

            <div className='grid--2col'>
              <div className="field">
                <label htmlFor="estadoUsuario">Estado del usuario</label>
                <div className="control">
                  <div className="select">
                    <select
                      className="select"
                      id="estadoUsuario"
                      required
                      name="estadoUsuario"
                      value={estadoUsuario}
                      onChange={(e) => setEstadoUsuario(e.target.value)}
                    >
                      <option disabled value="">-- Selecciona una opción --</option>
                      <option value="activo">Activo</option>
                      <option value="inactivo">Inactivo</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className='field'>
                <label htmlFor='cantidadAcumulada'>Cantidad acumulada</label>
                <div className='control'>
                  <input
                    className='input'
                    id='cantidadAcumulada'
                    name="cantidadAcumulada"
                    type='number'
                    value={credito}
                    onChange={(e) => setCredito(e.target.value)}
                  />
                </div>
              </div>
            </div>

          </fieldset>
        </form>
      </div>
      <div id='actions'>
        <button
          className='button is-link'
          id='saveButton'
          form='formUpdatelement'
          type='submit'
          disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
        <Link
          className='button is-link is-light'
          to={`../pacientes/${pacienteId}`}
        >
          Cancelar
        </Link>
        <button
          className='button is-danger'
          id='deleteButton'
          onClick={deleteUser}
          disabled={isDeletingButton}
        >
          {isDeletingButton ? <div className="spinner"></div> : 'Eliminar'}
        </button>
      </div>
    </>
  );
}
